import axios from "axios";

export function GetRequest(requestPath, token) {
  return axios.get(requestPath, {
    headers: {
      Authorization: "Bearer " + token,
    },
  });
}

export function PostRequest(requestPath, requestObject, token) {
  return axios.post(requestPath, requestObject, {
    headers: {
      Authorization: "Bearer " + token,
    },
  });
}
